/* SEW Assistant - shared product helpers.
   Shopify serves money in two different shapes depending on the endpoint:
     /products/<handle>.js and /recommendations  ->  integer cents  (99900)
     /products.json                              ->  decimal string ("999.00")
   readMoney() detects which one it was given, so no endpoint can be off by 100x. */
(function () {
  'use strict';

  function readMoney(v) {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return Math.round(v / 100);
    var s = String(v).trim();
    if (s.indexOf('.') > -1) return Math.round(parseFloat(s));
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n / 100);
  }

  function image(p) {
    if (p.featured_image) {
      return typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
    }
    var first = p.images && p.images[0];
    if (!first) return '';
    return typeof first === 'string' ? first : (first.src || '');
  }

  /* Accepts a product object from any of the three endpoints. */
  function toProduct(p) {
    if (!p || !p.id) return null;
    var variants = p.variants || [];
    var v = variants.filter(function (x) { return x && x.available; })[0] || variants[0] || {};
    var raw = (v.price !== undefined && v.price !== null) ? v.price : p.price;
    return {
      id: String(p.id),
      title: p.title || '',
      handle: p.handle || '',
      price: readMoney(raw),
      img: image(p),
      available: variants.length ? (v.available !== false) : (p.available !== false),
      variantId: v.id ? String(v.id) : null,
      url: '/products/' + p.handle
    };
  }

  window.SEWProduct = { readMoney: readMoney, toProduct: toProduct };
})();
